import { __decorate } from 'tslib';
import { Service } from '../../decorators/class/service.js';

/**
 * 用于追踪config被哪个controller注册
 * 同一个configName可能被多个controller注册，以最后的为准
 * @internal
 */
let TrackControllerService = class TrackControllerService {
    constructor() {
        // 用于存储静态配置来自哪个 Controller
        this.configControllers = new Map();
        // callbacks来自哪个 Controller
        this.callbackControllers = new Map();
    }
    getConfigController(key) {
        return this.configControllers.get(key);
    }
    getCallbackController(key) {
        return this.callbackControllers.get(key);
    }
    setConfigController(key, controller) {
        this.configControllers.set(key, controller);
    }
    setCallbackController(key, controller) {
        this.callbackControllers.set(key, controller);
    }
};
TrackControllerService = __decorate([
    Service({ overridable: true })
], TrackControllerService);

export { TrackControllerService };
//# sourceMappingURL=track-controller-service.js.map
